import { useTranslation } from 'react-i18next';
import { Card, List, Dropdown, Menu, Modal } from 'antd';
import {
  HomeOutlined,
  PhoneOutlined,
  MailOutlined,
  ExclamationCircleOutlined,
  EditOutlined,
  DeleteOutlined,
  SettingOutlined,
} from '@ant-design/icons';

const CardItem = ({ user, onDelete, onEdit, onSettings }) => {
  const { t } = useTranslation();
  const { confirm } = Modal;
  const { firstName, lastName, address, phone, email, role } = user;

  const showConfirm = () => {
    confirm({
      title: `${t('common.deleteQuestion')} ${firstName} ${lastName}?`,
      icon: <ExclamationCircleOutlined />,
      okType: 'danger',
      maskClosable: 'true',
      onOk() {
        onDelete(user.id);
      },
      onCancel() {},
      okText: t('common.yes'),
      cancelText: t('common.no'),
    });
  };

  const items = [
    {
      label: t('common.edit'),
      key: 'item-1',
      icon: <EditOutlined />,
      onClick: () => {
        onEdit(user);
      },
    },
    {
      label: t('carHouseUsers.settings'),
      key: 'item-2',
      icon: <SettingOutlined />,
      onClick: () => {
        onSettings(user);
      },
    },
    {
      type: 'divider',
    },
    {
      label: t('common.delete'),
      key: 'item-3',
      danger: true,
      icon: <DeleteOutlined />,
      onClick: () => {
        showConfirm();
      },
    },
  ];

  return (
    <List.Item>
      <Dropdown.Button
        style={{ position: 'absolute', right: '10px', top: '3px', zIndex: '1' }}
        className="dropdown-btn"
        overlay={<Menu mode="vertical" items={items} />}
      ></Dropdown.Button>
      <Card
        hoverable
        style={{
          boxShadow: 'rgb(178 213 198 / 56%) 2px 4px 8px 2px',
          borderRadius: '8px',
        }}
        headStyle={{
          borderBottom: 'none',
          color: 'var(--ant-primary-8)',
        }}
        bodyStyle={{}}
        title={`${firstName} ${lastName}`}
      >
        <p>
          <HomeOutlined
            style={{
              color: 'var(--ant-primary-6)',
              fontSize: '16px',
              marginRight: '10px',
            }}
          />
          {address}
        </p>
        <p>
          <MailOutlined
            style={{
              color: 'var(--ant-primary-6)',
              fontSize: '16px',
              marginRight: '10px',
            }}
          />
          {email}
        </p>
        <p>
          <PhoneOutlined
            style={{
              color: 'var(--ant-primary-6)',
              fontSize: '16px',
              marginRight: '10px',
            }}
          />
          {phone}
        </p>
      </Card>
    </List.Item>
  );
};

export default CardItem;
